import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { INews } from "./types/_news";
import { IPost, IComment } from "./types/_news";
import { PaginationResponse, ResponseData } from "./types/_public";
const api = new APIClient();

const path = '/news';
const newsApi = {
  posts(params: any): Promise<AxiosResponse<ResponseData<IPost[]> & PaginationResponse, any>> {
    const url = `/admin/posts`
    return api.get(url, params)
  },
  comments(params: any): Promise<AxiosResponse<ResponseData<IComment[]> & PaginationResponse, any>> {
    const url = `/admin/comments`
    return api.get(url, params)
  },
  actionRunPost(id: string | number, data: any = {}): Promise<AxiosResponse<ResponseData<IPost[]> & PaginationResponse, any>> {
    const url = `/admin/posts/${id}/retry`
    return api.post(url, data)
  },
  createPost(dataForm: any): Promise<AxiosResponse<ResponseData<IPost>, any>> {
    const url = `/admin/posts`;
    return api.post(url, dataForm)
  },
  actionCancelPost(id: string | number, data: any = {}): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `/admin/posts/${id}/cancel`
    return api.post(url, data)
  },
  aiNews(params: any): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `${path}`
    return api.get(url, params)
  },
  myNews(params: any): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `${path}/my-news`
    return api.get(url, params)
  },
  news(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<INews>>> {
    const url = `${path}/${id}`
    return api.get(url, params)
  },
  putNews(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<INews>, any>> {
    const url = `${path}/${id}`;
    return api.put(url, dataForm)
  },
  downloadNews(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `${path}/download`;
    const TYPE_DOWNLOAD: any = {
      COPY: 1,
      WORD: 2,
      PDF: 3
    };
    return api.post(url, {
      news_id: id,
      download_type: TYPE_DOWNLOAD?.[`${params?.type}`] || '',
      language_code: params?.language_code || 'ko',
    })
  },
  publishNews(id: string | number, data: any = {}): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `${path}/${id}/publish`;
    return api.post(url, data);
  },
  cancelMyNews(id: string | number, params: any): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `${path}/${id}/cancel-used`
    return api.put(url, params)
  },
  checkCurrentUsageNews(params: any = {}): Promise<AxiosResponse<ResponseData<any>>> {
    const url = `/daily-limit`
    return api.get(url, params)
  },
  publishPressconNews(id: string | number, data: any = {}): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `${path}/${id}/publish-presscon`;
    return api.post(url, data);
  },
  postCreateUsingAINews(dataForm: any = {}): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `${path}/create-using-ai`;
    const formData = new FormData();

    if (dataForm.files) {
      formData.append('files', dataForm.files);
    }

    if (dataForm.content) {
      formData.append('content', dataForm.content);
    }

    if (dataForm.keywords) {
      formData.append('keywords', dataForm.keywords);
    }

    if (dataForm.model) {
      formData.append('model', dataForm.model);
    }
    return api.post(url, formData, {
      timeout: 1000 * 60 * 10,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
}
export default newsApi
